/*
 * Copyright (C) 2024 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

// Establish data layer for Adobe Analytics
if (typeof window.adobeDataLayer === "undefined") {
  window.adobeDataLayer = [];
}

function loadAAModule(aaUrl) {
  const script = document.createElement('script');
  script.setAttribute('src', aaUrl);
  script.async = true;
  document.head.appendChild(script);
}

function pushAAEvent(
  aaEvent,
  pageName,
  userId,
  eventInfo,
  controlType,
  actionName,
  pageSection,
  actionBreadcrumb
) {
  let data;
  const sid = (userId || '').toUpperCase();
  const info = eventInfo || '';
  if (pageName === undefined || pageName === '') {
    // use page heading to identify page
    const h1Elements = document.getElementsByTagName("h1");

    pageName = h1Elements.length > 0 ? h1Elements[0].getAttribute("innerText") : '';
  }

  switch (aaEvent) {
    case "Page Load":
      data = {
        "event": aaEvent,
        "pageInfo": {
          pageName
        },
        "userInfo": {
          sid
        }
      };
      break;
    case "Exit":
      data = {
        "event": "Actions",
        "pageInfo": {
          pageName
        },
        "userInfo": {
          sid
        },
        "actionInfo": {
          "actionCategory": aaEvent,
          "actionControlType": controlType,
          "actionSection": pageSection,
          actionBreadcrumb,
          actionName,
          "actionDestinationURL": info,
          "actionIntent": "Active"
        }
      };
      break;
    default:
      break;
  }

  window.adobeDataLayer.push(data);
}

function addPageLoadEvent(pageName, sid) {
  pushAAEvent("Page Load", pageName, sid);
}

function addExitEvent(pageName, sId, exitUrl, controlType, actionName, pageSection, actionBreadcrumb) {
  pushAAEvent("Exit", pageName, sId, exitUrl, controlType, actionName, pageSection, actionBreadcrumb);
}

export { loadAAModule, addPageLoadEvent, addExitEvent };
